import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const CheckMarkOrange: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 74 74"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6218_1205)">
      <path
        d="M37 74C57.4345 74 74 57.4345 74 37C74 16.5655 57.4345 0 37 0C16.5655 0 0 16.5655 0 37C0 57.4345 16.5655 74 37 74Z"
        fill="white"
      />
      <path
        d="M24.5742 46.5537L18.3736 40.3532C16.6068 38.5864 16.6068 35.722 18.3736 33.9568L18.6896 33.6407C20.4564 31.874 23.3208 31.874 25.086 33.6407L31.2866 39.8413L24.5742 46.5537Z"
        fill="#3D3C38"
      />
      <path
        d="M48.6966 22.4312L24.5742 46.5537L31.2881 53.2676L55.4106 29.1452C58.4014 26.1544 56.2832 21.0406 52.0544 21.0406C50.7948 21.0406 49.5877 21.5417 48.6966 22.4312Z"
        fill="#FF612B"
      />
    </g>
    <defs>
      <clipPath id="clip0_6218_1205">
        <rect width="74" height="74" fill="white" />
      </clipPath>
    </defs>
  </Box>
)

export default CheckMarkOrange
